// extracted by mini-css-extract-plugin
export var LegalHeading = "CalculatorSectionModule-module--LegalHeading--1j8UN";
export var Section = "CalculatorSectionModule-module--Section--IG2Sp";
export var TableSection = "CalculatorSectionModule-module--TableSection--14-7S";
export var CalcTips = "CalculatorSectionModule-module--CalcTips--lgHvI";